import { makeSelectors } from '@utils/css';

const transitionDurationMs = 250;
const dialogContentCls = "dibdg7paub";
const focusOnContent = "dibf6vmcee";
const dialogCls = "dibd10y3974";
const backdropCls = "dibbm9h1mf";
const drawerSelectors = makeSelectors({
  content: dialogContentCls,
  dialog: dialogCls,
  backdrop: backdropCls
});

export { backdropCls, dialogCls, dialogContentCls, drawerSelectors, focusOnContent, transitionDurationMs };
import "./drawer.style.linaria.module.css";
//# sourceMappingURL=drawer.style.js.map
